// extracted by mini-css-extract-plugin
export var actionText = "_rh-4";
export var container = "_rh-0";
export var leftSection = "_rh-1";
export var rightSection = "_rh-2";
export var settingsButton = "_rh-6";
export var settingsIcon = "_rh-7";
export var shortcut = "_rh-5";
export var shortcutGroup = "_rh-3";